export default __webpack_public_path__ + "static/media/promo-icon.369c419b.svg";